import React from 'react';
import {
  Container,
  Typography,
  Paper,
  Box,
} from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

const ThankYou = () => {
  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          py: 4,
        }}
      >
        <Paper
          elevation={3}
          sx={{
            p: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 3,
          }}
        >
          <CheckCircleOutlineIcon
            color="success"
            sx={{ fontSize: 64, mb: 2 }}
          />
          <Typography variant="h4" component="h1" align="center" gutterBottom>
            Thank You!
          </Typography>
          <Typography variant="body1" align="center">
            We appreciate you taking the time to complete our interview.
            Our team will review your responses and get back to you shortly.
          </Typography>
          <Typography variant="body2" align="center" color="text.secondary">
            You may close this window now.
          </Typography>
        </Paper>
      </Box>
    </Container>
  );
};

export default ThankYou; 